import React from 'react'

// Types
import { SignupProps } from '../types'

// Hooks 
import { useState, useContext } from 'react'

// Context
import { AuthContext } from '../context'
import { useTranslation } from 'react-i18next'

// Styles 
import styles from '../styles/Forms.scss'

// Components 
import { RequiredValidator, EmailValidator, EqualValidator } from '../../validation'
import { Column, Row } from 'columns'

const Signup: React.FC<SignupProps> = (props) => {

  const { t } = useTranslation()

  const [errors, setErrors] = useState({
    email: false,
    password: false,
    passwordRepeat: false,
    firstName: false,
    lastName: false,
    address: false,
    zip: false,
    city: false,
    country: false,
  })

  const [ user, setUser ] = useState({
    email: '',
    password: '',
    passwordRepeat: '',
    firstName: '',
    lastName: '',
    address: '',
    zip: '',
    city: '',
    country: '',
  })
  
  const {
    email,
    password,
    passwordRepeat,
    firstName,
    lastName,
    address,
    zip,
    city,
    country
  } = user
  const auth = useContext(AuthContext)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target
    setUser({ ...user, [name]: value })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    auth.actions.signup(user)
  }

  return (
    <form onSubmit={handleSubmit}>

      <div className={styles.formGroup}>
        <label htmlFor="email">{t('signup.email')} *</label>
        <input type="email" name="email" value={email} onChange={handleChange} />
        <EmailValidator required={true} className={styles.validationMessage} value={email}>{t('signup.validation.email')}</EmailValidator>
      </div>
      
      <Row className={styles.formGroup}>
        <Column>
          <label htmlFor="password">{t('signup.password')} *</label>
          <input type="password" name="password" value={password} onChange={handleChange} />
          <RequiredValidator className={styles.validationMessage} value={password}>{t('signup.validation.password')}</RequiredValidator>
        </Column>

        <Column>
          <label htmlFor="passwordRepeat">{t('signup.passwordRepeat')} *</label>
          <input type="password" name="passwordRepeat" value={passwordRepeat} onChange={handleChange} />
          <EqualValidator required={true} className={styles.validationMessage} equals={password} value={passwordRepeat}>{t('signup.validation.password')}</EqualValidator>
        </Column>
      </Row>

      <Row className={styles.formGroup}>
        <Column>
          <label htmlFor="firstName">{t('signup.firstname')} *</label>
          <input name="firstName" value={firstName} onChange={handleChange} />
          <RequiredValidator className={styles.validationMessage} value={firstName}>{t('signup.validation.firstname')}</RequiredValidator>
        </Column>

        <Column>
          <label htmlFor="lastName">{t('signup.lastname')} *</label>
          <input name="lastName" value={lastName} onChange={handleChange} />
          <RequiredValidator className={styles.validationMessage} value={lastName}>{t('signup.validation.lastname')}</RequiredValidator>
        </Column>
      </Row>
      
      <div className={styles.formGroup}>
        <label htmlFor="address">{t('signup.address')} *</label>
        <input name="address" value={address} onChange={handleChange} />
        <RequiredValidator className={styles.validationMessage} value={address}>{t('signup.validation.address')}</RequiredValidator>
      </div>

      <Row className={styles.formGroup}>
        <Column>
          <label htmlFor="zip">{t('signup.zip')} *</label>
          <input name="zip" value={zip} onChange={handleChange} />
          <RequiredValidator className={styles.validationMessage} value={zip}>{t('signup.validation.zip')}</RequiredValidator>
        </Column>

        <Column>
          <label htmlFor="city">{t('signup.city')} *</label>
          <input name="city" value={city} onChange={handleChange} />
          <RequiredValidator className={styles.validationMessage} value={city}>{t('signup.validation.city')}</RequiredValidator>
        </Column>
      </Row>
      
      <div className={styles.formGroup}>
        <label htmlFor="country">{t('signup.country')} *</label>
        <select name="country" value={country} onChange={handleChange}>
          <option></option>
          <option value="Danmark">Danmark</option>
        </select>
        <RequiredValidator className={styles.validationMessage} value={country}>{t('signup.validation.country')}</RequiredValidator>
      </div>

      {auth.signupError && (
        <div className={styles.errorBox}>{auth.signupError}</div>
      )}

      <div className={styles.formGroup}>
        <button>{t('signup.signupButton')}</button>
      </div>
    </form>
  )

}

export default Signup